var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4AC85255-9EC3-4401-9AA7-2F36987B1DE5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insights",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin/Rows-Selected",
    transform: "translate(-88.000000, -295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Menu",
    transform: "translate(64.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Copy",
    transform: "translate(0.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Settings-Icon",
    transform: "translate(24.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875,5.625 L16.875,4.5 L15.6931313,4.5 C15.6205998,4.14790972 15.4808136,3.81312176 15.2814375,3.51399375 L16.1195625,2.67586875 L15.3241875,1.88049375 L14.4860625,2.71861875 C14.1869218,2.51921623 13.8521139,2.37941053 13.5,2.30686875 L13.5,1.125 L12.375,1.125 L12.375,2.30686875 C12.0229097,2.3794002 11.6881218,2.51918645 11.3889938,2.7185625 L10.5508688,1.8804375 L9.75549375,2.6758125 L10.5936188,3.5139375 C10.3942162,3.81307818 10.2544105,4.1478861 10.1818687,4.5 L9,4.5 L9,5.625 L10.1818687,5.625 C10.2544002,5.97709028 10.3941864,6.31187824 10.5935625,6.61100625 L9.7554375,7.44913125 L10.5508125,8.24450625 L11.3889375,7.40638125 C11.6880782,7.60578377 12.0228861,7.74558947 12.375,7.81813125 L12.375,9 L13.5,9 L13.5,7.81813125 C13.8520903,7.7455998 14.1868782,7.60581355 14.4860062,7.4064375 L15.3241312,8.2445625 L16.1195062,7.4491875 L15.2813812,6.6110625 C15.4807838,6.31192182 15.6205895,5.9771139 15.6931312,5.625 L16.875,5.625 Z M12.9375,6.75 C12.0055195,6.75 11.25,5.99448052 11.25,5.0625 C11.25,4.13051948 12.0055195,3.375 12.9375,3.375 C13.8694805,3.375 14.625,4.13051948 14.625,5.0625 C14.623977,5.99405644 13.8690564,6.74897697 12.9375,6.75 L12.9375,6.75 Z",
    id: "Shape",
    fill: "#194A74",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.875 L7.875,16.875 L7.875,14.0625 C7.87397697,13.1309436 7.11905644,12.376023 6.1875,12.375 L3.9375,12.375 C3.00594356,12.376023 2.25102303,13.1309436 2.25,14.0625 L2.25,16.875 L1.125,16.875 L1.125,14.0625 C1.12682877,12.5099573 2.38495727,11.2518288 3.9375,11.25 L6.1875,11.25 C7.74004273,11.2518288 8.99817123,12.5099573 9,14.0625 L9,16.875 Z",
    id: "Path",
    fill: "#194A74",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0625,5.625 C5.99448052,5.625 6.75,6.38051948 6.75,7.3125 C6.75,8.24448052 5.99448052,9 5.0625,9 C4.13051948,9 3.375,8.24448052 3.375,7.3125 C3.375,6.38051948 4.13051948,5.625 5.0625,5.625 M5.0625,4.5 C3.50919914,4.5 2.25,5.75919914 2.25,7.3125 C2.25,8.86580086 3.50919914,10.125 5.0625,10.125 C6.61580086,10.125 7.875,8.86580086 7.875,7.3125 C7.875,6.56657862 7.57868389,5.85120824 7.05123782,5.32376218 C6.52379176,4.79631611 5.80842138,4.5 5.0625,4.5 Z",
    id: "Shape",
    fill: "#194A74",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.a09faa56.svg";
export { ForwardRef as ReactComponent };